import script from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=4886ba21&lang=scss"

const __exports__ = script;

export default __exports__